import { z } from 'zod'

/**
 * Research enabled parameter for agent/assistant request params
 */
export const LRRSearchFilterSchema = z.object({
  jurisdiction_codes: z.array(z.string()),
})

export type LRRSearchFilter = z.infer<typeof LRRSearchFilterSchema>

export const CaselawSearchFilterSchema = z.object({
  jurisdiction_codes: z.array(z.string()),
  date_low: z.string().datetime({ message: 'Invalid date format. Expected ISO 8601 datetime string' }).nullable().optional(),
  date_high: z.string().datetime({ message: 'Invalid date format. Expected ISO 8601 datetime string' }).nullable().optional(),
  include_unpublished_cases: z.boolean().default(false),
})

export type CaselawSearchFilter = z.infer<typeof CaselawSearchFilterSchema>

const UserFilesRAGRequestSchema = z.object({
  user_file_ids: z.array(z.string()).default([]),
})

const WritingSampleFilesRequestSchema = z.object({
  user_file_ids: z.array(z.string()).default([]),
})

/** What an uploaded or selected file attaches to: the multi-file user_files (RAG) field, or the single writing sample. */
export type FileSelectionTarget = 'user-files' | 'writing-sample'

/**
 * Current Agent Assistant request params.
 * This is the submit-capable frontend contract, not the broader historical response model.
 *
 * Default values are provided for each field.
 */
export const AgentAssistantRequestParamsSchema = z.object({
  user_files_rag: UserFilesRAGRequestSchema.default({ user_file_ids: [] }),
  writing_sample_files: WritingSampleFilesRequestSchema.default({ user_file_ids: [] }),
  caselaw_search_filter: CaselawSearchFilterSchema.nullish(),
  lrr_search_filter: LRRSearchFilterSchema.nullish(),
})

export type AgentAssistantRequestParams = z.infer<typeof AgentAssistantRequestParamsSchema>
